/* eslint-disable array-callback-return */
import React, { Component } from 'react';


class Button extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: new Date(),
            error: [],
            feild: {},
        };
    }
    componentDidMount() {
        let { feild_data } = this.props;
        this.setState({ 'feild': feild_data })
    }

    buttonClick(){
        let { feild_data } = this.props;
        this.props.buttonClick(feild_data)
    }

    render() {
        let { feild_data } = this.props;
        return (
            <React.Fragment>
               
                    <div className={`${feild_data.class['cols']? feild_data.class['cols'] :'col-12'} mx-auto mt-4`}>
                        <button type="button" className={`btn w-100 ${feild_data.class['button']}`} onClick={()=>this.buttonClick()}>{feild_data.title}</button>
                    </div>
               
            </React.Fragment>
        );
    }
}

export default Button;
